import { AssignChatRequest, AssignChatResponse, CloseChatSessionRequest, CloseChatSessionResponse, Result } from '../types';
import { ApiClient } from './apiClient';

export class ChatService {
  constructor(private apiClient: ApiClient) { }

  async closeSession(payload: CloseChatSessionRequest): Promise<Result<CloseChatSessionResponse>> {
    return this.apiClient.post<CloseChatSessionResponse>('/api/chats/close', payload);
  }

  async assignChat(payload: AssignChatRequest): Promise<Result<AssignChatResponse>> {
    return this.apiClient.post<AssignChatResponse>('/api/chats/assign', payload);
  }
}
